import { ICompanySettings } from "modules/company/types";
import { sendPutRequest } from "services/apiService";

interface FailedServerResponse extends IGenericAPIResponse {
  status: undefined;
}

type CompanySettingResponse =
  | {
      status: true;
      companySettings: ICompanySettings;
    }
  | FailedServerResponse;

export const getRequestURL = (companyId: string) =>
  `/company/${companyId}/settings/disable-vpn-check`;

const request = async (companyId: string, disableVPNCheck: boolean) => {
  const resp = await sendPutRequest<
    { disableVPNCheck: boolean },
    CompanySettingResponse
  >(getRequestURL(companyId), { disableVPNCheck });

  if (!resp.status) {
    throw new Error(resp?.message ?? resp?.error);
  }

  return resp.companySettings;
};

export default request;
